import {SeatingPlanModel} from "../SeatingPlanModel";
import {useFormDialogAction} from "../../../components/form-dialog/FormDialogProvider";
import {SeatingPlanFormDialog} from "../../seating-plan-list-page/SeatingPlanFormDialog";
import {ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import React, {useCallback} from "react"
import {useSeatingPlanStore} from "../../../api/SeatingPlanStore";
import {PageAction} from "../../../components/page-action/PageActionHandler";
import {usePermission} from "../../../util/access/UseAccess";
import {SeatingPlans_Admin} from "../../../util/access/Permission";

export const editPlanAction: PageAction<SeatingPlanModel> = {
    type: 'menu-item',
    component: (model: SeatingPlanModel, actionHandler) => (
        <EditSeatingPlanButton model={model} onClick={actionHandler} key="editPlanAction"/>
    ),
};

function EditSeatingPlanButton({model, onClick}: {
    model: SeatingPlanModel,
    onClick: () => void,
}) {
    const plan = model.plan;
    const {updatePlan} = useSeatingPlanStore();
    const {canAdmin} = usePermission({canAdmin: SeatingPlans_Admin});

    const handleEditPlan = useFormDialogAction({
        title: 'Edit Seating Plan',
        description: 'Update the seating plan information below.',
        submitButtonText: 'Update',
        renderForm: SeatingPlanFormDialog,
        action: (openDialog) => {
            openDialog({
                initialValue: {
                    name: plan.name,
                    description: plan.description,
                },
                onSubmit: form => updatePlan(plan, form),
                successMessage: form => `Updated seating plan ${form.name}.`,
                errorMessage: 'Failed to update the seating plan. Please try again later.',
            });
        },
    }, [plan, updatePlan]);

    const handleClick = useCallback(() => {
        handleEditPlan();
        onClick();
    }, [handleEditPlan, onClick]);


    return canAdmin ? (
        <MenuItem onClick={handleClick}>
            <ListItemIcon>{<EditIcon/>}</ListItemIcon>
            <ListItemText>Edit</ListItemText>
        </MenuItem>
    ) : null;
}
